var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.handleScreenFull}},[_c('icon',{class:`${_vm.iconClass}`,attrs:{"name":"fullscreen","scale":_vm.scale}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }